import EventEmitter from '../utils/EventEmitter';
import dispatcher from '../dispatcher';
import resizeStore from '../resize/resize.store';

var eventEmitter = new EventEmitter();

var pageX = resizeStore.getData().width / 2;
var pageY = resizeStore.getData().height / 2;
var screenX = pageX;
var screenY = pageY;
var speed = 0;
var speedX = 0;
var speedY = 0;
var show = false;

var _handleEvent = function(e) {
	if (e.type === 'cursor:show' && !show) {
		show = true;
		eventEmitter.dispatch();
	}
	if (e.type === 'cursor:hide' && show) {
		show = false;
		eventEmitter.dispatch();
	}
}

var _handleMouseMove = function(e) {
	pageX = e.pageX;
	pageY = e.pageY;
	screenX = e.clientX;
	screenY = e.clientY;

	if (Modernizr.mobile && Modernizr.touchevents) return;

	speedX = e.movementX;
	speedY = e.movementY;

	speed = Math.pow(Math.pow(speedX, 2) + Math.pow(speedY, 2), 0.5);

	eventEmitter.dispatch();
}

var getData = function() {
	return {
		pageX: pageX,
		pageY: pageY,
		screenX: screenX,
		screenY: screenY,
		speedX: speedX,
		speedY: speedY,
		speed: speed,
		show: show
	}
}

var _init = function() {
	dispatcher.subscribe(_handleEvent);
	window.addEventListener('mousemove', _handleMouseMove, {
		passive: true
	});
}

_init();

export default {
	subscribe: eventEmitter.subscribe.bind(eventEmitter),
	unsubscribe: eventEmitter.unsubscribe.bind(eventEmitter),
	getData: getData
}